/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Plans_Pay_As_You_Go_TitleInputs */

const es_components_upgrade_plan_modal_plans_pay_as_you_go_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Pay_As_You_Go_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago por uso`)
};

const en_components_upgrade_plan_modal_plans_pay_as_you_go_title = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Pay_As_You_Go_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay as you go`)
};

/**
* | output |
* | --- |
* | "Pay as you go" |
*
* @param {Components_Upgrade_Plan_Modal_Plans_Pay_As_You_Go_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_plans_pay_as_you_go_title = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Plans_Pay_As_You_Go_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Plans_Pay_As_You_Go_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_plans_pay_as_you_go_title(inputs)
	return en_components_upgrade_plan_modal_plans_pay_as_you_go_title(inputs)
});
export { components_upgrade_plan_modal_plans_pay_as_you_go_title as "components.upgrade_plan_modal.plans.pay_as_you_go.title" }